export { Title } from './Title';
export type { Props } from './Title.types';
